import { useEffect, useState } from "react";
import { NAV, SITE_NAME } from "./brand";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6 h-16">
        <a
          href="#hero"
          className="flex items-center gap-2.5 text-foreground-950 whitespace-nowrap"
          aria-label="回到顶部"
        >
          <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-search-eye-line text-lg" />
          </span>
          <span className="text-xl font-semibold font-heading">
            {SITE_NAME}
            <span className="ml-2 hidden lg:inline text-xs font-body font-normal text-secondary-700 align-middle">
              吃瓜先求真 · 把瓜看准
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm text-foreground-800 hover:text-primary-600 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-2 text-sm hover:bg-primary-600 transition-colors"
          >
            <i className="ri-focus-3-line" />
            我要求证
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-900"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {/* 移动端折叠菜单 */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200 ${
          open ? "max-h-[420px]" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col gap-1 px-4 py-4">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="flex items-center justify-between rounded-lg px-3 py-3 text-sm text-foreground-800 hover:bg-background-100"
            >
              {item.label}
              <i className="ri-arrow-right-up-line text-secondary-600" />
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-3 text-sm hover:bg-primary-600"
          >
            <i className="ri-focus-3-line mr-1.5" />
            我要求证
          </a>
        </nav>
      </div>
    </header>
  );
}